import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LineChart from '../common/Charts/LineChart';
import { numberWithCommas } from '../../util/CommonUtils';
import {
  DAY_IN_LIFE_ICONS,
  calculateAsterisk,
  isMRISpecificStudy,
  calculateMRIAsterisk,
} from '../../util/QuickReportsUtils';
import { MODULE_DAY_IN_LIFE } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

const categories = [
  '12A',
  '1A',
  '2A',
  '3A',
  '4A',
  '5A',
  '6A',
  '7A',
  '8A',
  '9A',
  '10A',
  '11A',
  '12P',
  '1P',
  '2P',
  '3P',
  '4P',
  '5P',
  '6P',
  '7P',
  '8P',
  '9P',
  '10P',
  '11P',
  '12A',
];

const dropdown = [
  { key: 'ALL', value: 'All Week' },
  { key: 'WKDAY', value: 'Weekdays Only' },
  { key: 'WKEND', value: 'Weekends Only' },
  { key: '1', value: 'Sunday' },
  { key: '2', value: 'Monday' },
  { key: '3', value: 'Tuesday' },
  { key: '4', value: 'Wednesday' },
  { key: '5', value: 'Thursday' },
  { key: '6', value: 'Friday' },
  { key: '7', value: 'Saturday' },
];

export default class DayInLife extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'Percent',
      selectedDropdown: 'ALL',
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
      selectedReportType: 'DIL_S',
    };
  }

  componentDidMount() {
    this.props.handletitle('Day In Life');
    this.props.handleExportParams(
      this.state.selectedRadioButton,
      undefined,
      undefined
    );
    this.props.trackerFn({ subModule: MODULE_DAY_IN_LIFE });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps() {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
  }

  handleDropdownChange = e => {
    this.props.runReport(
      null,
      null,
      `${this.state.selectedReportType}_${e.currentTarget.value}`
    );
    this.setState({ selectedDropdown: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        undefined,
        undefined
      );
    });
  };

  handleRadioButtonChange = e =>
    this.setState({ selectedRadioButton: e.currentTarget.value }, () => {
      this.props.handleExportParams(
        this.state.selectedRadioButton,
        undefined,
        undefined
      );
    });

  handleReportTypeChange = e => {
    this.props.runReport(
      null,
      null,
      `${e.currentTarget.value}_${this.state.selectedDropdown}`
    );
    this.setState({ selectedReportType: e.currentTarget.value });
  };

  processData = data =>
    Object.keys(data).map(key => ({
      name: key,
      data: data[key]
        ? data[key].reduce((accumulator, currentValue) => {
            let asterisk;
            if (isMRISpecificStudy(this.props.study)) {
              asterisk = calculateMRIAsterisk(
                currentValue.value.sample,
                this.props.study.wnt
              );
            } else {
              asterisk = calculateAsterisk(currentValue.value.sample);
            }
            this.updateAsteriskStatus(asterisk);
            return [
              ...accumulator,
              {
                y:
                  this.state.selectedRadioButton === 'Index'
                    ? Number(currentValue.value.index)
                    : Number(
                        currentValue.value.pct.toString().replace(/%/g, '')
                      ),
                name: `${key}: ${currentValue.label}`,
                value: {
                  index: currentValue.value.index,
                  sample: numberWithCommas(currentValue.value.sample),
                  weighted: numberWithCommas(currentValue.value.weighted),
                  pct: Math.round(
                    Number(currentValue.value.pct.replace(/%/g, ''))
                  ),
                  asterisk,
                },
              },
            ];
          }, [])
        : [],
    }));

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  renderDropdown = () =>
    dropdown.map(({ key, value }) => (
      <option value={key} key={key}>
        {value}
      </option>
    ));

  renderImageTable = data =>
    Object.keys(data).map(key => (
      <div className="display-inline text-center day-in-life-icons">
        <img alt={key} src={DAY_IN_LIFE_ICONS[key].icon} />
        <br />
        <p style={{ color: DAY_IN_LIFE_ICONS[key].color }}>{key}</p>
      </div>
    ));

  render() {
    return (
      <div className="quick-report-graph-wrapper day-in-life-wrapper">
        <div className="large-12 text-center margin-top-10 margin-bottom-15 clearfix">
          <div className="quick-report-dropdown display-inline float-left padding-left-15">
            <select
              onChange={this.handleDropdownChange}
              value={this.state.selectedDropdown}
            >
              {this.renderDropdown()}
            </select>
          </div>
          <div className="quick-report-radio no-bg display-inline float-left">
            <p>
              <input
                type="radio"
                id="smartphoneType"
                name="ReportType"
                checked={this.state.selectedReportType === 'DIL_S'}
                onChange={this.handleReportTypeChange}
                value="DIL_S"
              />
              <label htmlFor="smartphoneType">
                <span>Smartphone</span>
              </label>
            </p>
            <p>
              <input
                type="radio"
                id="cameraType"
                name="ReportType"
                checked={this.state.selectedReportType === 'DIL_C'}
                onChange={this.handleReportTypeChange}
                value="DIL_C"
              />
              <label htmlFor="cameraType">
                <span>Mobile</span>
              </label>
            </p>
          </div>
          <div className="quick-report-radio display-inline float-right padding-right-15">
            <p>
              <input
                type="radio"
                id="percentType"
                name="ChartType"
                checked={this.state.selectedRadioButton === 'Percent'}
                onChange={this.handleRadioButtonChange}
                value="Percent"
              />
              <label htmlFor="percentType">
                <span>Percent</span>
              </label>
            </p>
            <p>
              <input
                type="radio"
                id="indexType"
                name="ChartType"
                checked={this.state.selectedRadioButton === 'Index'}
                onChange={this.handleRadioButtonChange}
                value="Index"
              />
              <label htmlFor="indexType">
                <span>Index</span>
              </label>
            </p>
          </div>
        </div>
        <div className="column large-11 text-center clearfix">
          {this.renderImageTable(this.props.data)}
        </div>
        <div className="column large-12">
          <LineChart
            chartColor={chartColor}
            yLabel={
              this.state.selectedRadioButton === 'Percent'
                ? '{value}%'
                : '{value}'
            }
            data={{
              series: this.processData(this.props.data),
              tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
            }}
            categories={categories}
            dataLabels
            yAxisText={
              this.state.selectedRadioButton === 'Percent'
                ? 'Percentage'
                : 'Index'
            }
            tickPlacement="on"
            legend={{
              enabled: true,
              align: 'right',
              verticalAlign: 'top',
              layout: 'vertical',
              x: 0,
              y: 0,
              lineHeight: 32,
              itemStyle: {
                color: 'RGB(48, 67, 93)',
                fontSize: '12px',
                fontWeight: 'normal',
              },
            }}
          />
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick display-inline font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

DayInLife.propTypes = {
  data: PropTypes.shape({}),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  runReport: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({
    wnt: PropTypes.number,
  }),
};
